import { FC, useMemo } from 'react';
import swiperCss from '@edikk-edikk/country-common/css/modules/swiper.module.scss';
import { AdvertPhotoType } from '@edikk-edikk/country-common';
import { useBotDetectorContext } from '@edikk-edikk/country-frontend';
import classNames from 'classnames';
import galleryItemCss from '../../../assets/gallery/gallery-item.module.scss';
import { useAdvertDetailContext } from '#advertDetail/hooks';

type PropsType = {
  photo: AdvertPhotoType;
};

const GalleryItem: FC<PropsType> = ({
  photo,
}) => {
  const { isBot } = useBotDetectorContext();
  const {
    advert: {
      isDeleted,
    },
  } = useAdvertDetailContext();
  const withBlur = useMemo(() => !isBot && isDeleted, [isBot, isDeleted]);

  return (
    <div className={classNames(swiperCss.swiper__slide, galleryItemCss.galleryItem)}>
      <img
        src={photo.url}
        className={classNames(
          galleryItemCss.galleryItem__img,
          { [galleryItemCss.galleryItem__img_withBlur]: withBlur },
        )}
      />
    </div>
  );
};

export { GalleryItem };
